import { render, staticRenderFns } from "./GallerySlider.vue?vue&type=template&id=7a842922&scoped=true&"
import script from "./GallerySlider.vue?vue&type=script&lang=js&"
export * from "./GallerySlider.vue?vue&type=script&lang=js&"
import style0 from "./GallerySlider.vue?vue&type=style&index=0&id=7a842922&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a842922",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib'
import { VCarouselItem } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VCarousel,
  VCarouselItem,
  VFlex,
  VImg,
  VLayout,
})
